import React from 'react';
import Viewer from 'viewerjs';
import {post} from '../../utils/request';
import api from './api';
import './index.less';
import 'viewerjs/dist/viewer.css';

class newsDetail extends React.Component {
  constructor(props) {
    super(...props);
    this.state = {
        data:[],
        urlOps: {}
    }
  }
  componentWillMount() {

    var obj = '',obj1 = '',ops={};
    if(window.location.hash.indexOf('?') > -1 ){
        obj = window.location.hash.split('?')[1];
        obj1 = obj.split('&');
        for(var i=0;i<obj1.length;i++){
            ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
        }
        const {access_token} = ops;
        this.setState({
          urlOps: ops
        },()=>{
          post({
            url: api.appNewView,
            data:{
              contentId: ops.id
            },
            preventXXSKey: 'contentRemark'
          }).then((res) => {
              // Toast.info(res.msg,1);
              if(res.result === 'success'){
                document.getElementsByTagName('title')[0].text = res.data.contentTitle;

                this.setState({
                  data: res.data
                });
              }else{
              }
          }, (res)=>{
              console.log('查询新闻详情失败', res)
          });
        });
    }
  }
  componentDidMount(){
    new Viewer(document.getElementById('newsDetailBox'), {
      navbar:false,
      toolbar: false,
      title: false,
      url: 'data-original'
    });
  }

  render() {
    const {data, urlOps} = this.state;

    return (
      <div className="findDetailBox" id="newsDetailBox">

          <h1>{data.contentTitle}</h1>
          <div className="source" style={{margin: 0,padding: "0.08rem 0 0.04rem 0", border: "0"}}>
              <span>{data.contentAttr}</span>
          </div>
          <div className="source">
              {/* <span className="author">{data.contentSource}</span> */}
              <span>{data.contentSource}</span>
              <span>{data.gmtCreate}</span>
          </div>
          <div className="content" dangerouslySetInnerHTML={{__html: data.contentRemark}}></div>
      </div>
    );
  }
}

export default newsDetail;



// WEBPACK FOOTER //
// ./src/news/detail/index.js